import React from "react";
import classes from "./ToolResponse.scss";
import { connect } from "react-redux";

import RubricTable from "Rubric/components/RubricTable";
import ChecklistTable from "Checklist/components/ChecklistTable";
import MYPObjectiveRubric from "UnitPlans/components/IBcomponents/AssessmentTool/MYPObjectiveRubric";
import PropTypes from "prop-types";

class ToolResponse extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      toolType,
      assessmentTool,
      insights,
      insightColor,
      mypObjectiveRubricOptions,
      ibPYPElementRatings,
      rubricInnerConStyle,
      shouldTakeFullWidth,
    } = this.props;
    let toolResoponseComponent = null;
    switch (toolType) {
      case "RUBRIC":
        toolResoponseComponent = (
          <RubricTable
            mode={"view"}
            rubric={assessmentTool}
            showInsight={true}
            insightColor={insightColor}
            insights={insights}
            innerConStyle={rubricInnerConStyle}
            shouldTakeFullWidth={shouldTakeFullWidth}
          />
        );
        break;
      case "CHECKLIST":
        toolResoponseComponent = (
          <ChecklistTable
            checklist={assessmentTool}
            mode={"view"}
            showInsight={true}
            insights={insights}
            insightColor={insightColor}
          />
        );
        break;
      case "MYP_OBJECTIVE_RUBRIC":
      case "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC":
        toolResoponseComponent = (
          <MYPObjectiveRubric
            assessmentTool={assessmentTool}
            mode={"view"}
            showInsight={true}
            insights={insights}
            insightColor={insightColor}
            options={mypObjectiveRubricOptions}
            ibPYPElementRatings={ibPYPElementRatings}
          />
        );
        break;
    }
    return !!toolResoponseComponent ? (
      <div className={classes.container}>{toolResoponseComponent}</div>
    ) : null;
  }
}

ToolResponse.propTypes = {
  shouldTakeFullWidth: PropTypes.bool,
};

ToolResponse.defaultProps = {
  shouldTakeFullWidth: false,
};

const mapActionCreators = {};

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps, mapActionCreators)(ToolResponse);
